import styled, {css, keyframes} from "styled-components"

import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"

interface IndicatorProps {
  steps: number
  active: number
}

const baseIndicatorStyles = css`
  position: relative;
  height: 10px;
  border-radius: 10px;
`

const progress = (active: number, steps: number) => keyframes`
  from { width: 0%; }
  to {  width: ${(100 / steps) * active}%; }
`

export const CustomCard = styled(Card)`
  background: linear-gradient(180deg, rgba(240, 191, 69, 0.1) 0%, rgba(235, 83, 114, 0.1) 100%);
`

export const StepsIndicator = styled.div`
  ${baseIndicatorStyles}
  width: 100%;
  background-color: ${({theme}) => theme.colors.greys.light};
`

export const ActiveBar = styled.div<IndicatorProps>`
  ${baseIndicatorStyles}
  width: ${({active, steps}: IndicatorProps) => (100 / steps) * active}%;
  background: linear-gradient(270deg, #64d67d 0%, #2accaf 96.75%);
  animation: ${({active, steps}: IndicatorProps) => progress(active, steps)} 3s linear;
`

export const FinalStep = styled.img`
  position: absolute;
  right: -${({theme}) => theme.spacing.four};
  top: -${({theme}) => theme.spacing.two};
`

export const StepContainer = styled(Flex)`
  background-color: ${({theme}) => theme.colors.utility.highlight};
  border-radius: ${({theme}) => theme.spacing.one};
`
export const StepChip = styled(Flex)`
  background-color: ${({theme}) => theme.colors.utility.white};
  padding: ${({theme}) => `${theme.spacing.one} ${theme.spacing.oneAndHalf}`};
  min-height: ${({theme}) => theme.spacing.five};
  border-radius: 18px;
`
